import axios from 'axios';
import { getGlobalCurrentBatchUtils, getGlobalSchoolUtils } from 'utils/commonFunc';
import constants from '../../config/constants';

export const GET_ALL_COURSES = 'GET_ALL_COURSES';
export const GET_SCHOOL_COURSES = 'GET_SCHOOL_COURSES';
export const GET_BATCH_COURSES = 'GET_BATCH_COURSES';
export const GET_COURSE = 'GET_COURSE';
export const GET_EMP_COURSES = 'GET_EMP_COURSES';
export const GET_SCHOOL_COURSES_WP = 'GET_SCHOOL_COURSES_WP';

//= ========== Reducer call functions begin ===========//
export const getBatchCoursesWithPage = courseData => ({
  type: GET_ALL_COURSES,
  courseData,
});

export const getSchoolCoursesWithPage = schCourseData => ({
  type: GET_SCHOOL_COURSES_WP,
  schCourseData,
});

export const getSchoolCourses = courses => ({
  type: GET_SCHOOL_COURSES,
  courses,
});

export const getEmpCourses = empCourses => ({
  type: GET_EMP_COURSES,
  empCourses,
});

export const getBatchCoursesWithoutPage = batchCourses => ({
  type: GET_BATCH_COURSES,
  batchCourses,
});

export const getCourse = course => ({
  type: GET_COURSE,
  course,
});
//= ========== Reducer call functions begin ===========//

//= ========== User routing begin ===========//
const status = 'ACTIVE';
export const fetchBatchCoursesWithPageService = data => async dispatch => {
  const url = `${constants.API_BASE_URL}/api/admin/get-school-course-by-page/${data.schoolId}/${
    data.batchId
  }/${status}${constants.makeParams(data.pageParams)}`;
  try {
    const res = await axios.get(url, constants.setHeader(data.token));
    return dispatch(getBatchCoursesWithPage(res.data));
  } catch (err) {
    console.error(err.response);
  }
};

export const fetchSchoolCoursesWithPageService = data => async dispatch => {
  const url = `${constants.API_BASE_URL}/api/admin/get-school-course-by-page/${
    data.schoolId
  }/${status}${constants.makeParams(data.pageParams)}`;
  try {
    const res = await axios.get(url, constants.setHeader(data.token));
    return dispatch(getSchoolCoursesWithPage(res.data));
  } catch (err) {
    console.error(err.response);
  }
};

export const fetchSchoolCoursesWithoutPageService = data => async dispatch => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/admin/get-school-course/${data.schoolId}/${status}`,
      constants.setHeader(data.token)
    );
    dispatch(getSchoolCourses(res.data));
    return res.data;
  } catch (err) {
    console.error(err.response);
  }
};

export const GET_SCHOOL_BATCH_COURSES = 'GET_SCHOOL_BATCH_COURSES';
export const getSchoolBatchCourses = schoolBatchCourseList => ({
  type: GET_SCHOOL_BATCH_COURSES,
  schoolBatchCourseList,
});
const fetchSchoolBatchCourseApi = async data => {
  const { batchId = data?.batchId } = getGlobalCurrentBatchUtils();
  const { schoolId = data.schoolId } = getGlobalSchoolUtils();
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/admin/get-school-course/${schoolId}/${batchId}/${status}`,
      constants.setHeader(data.token)
    );
    return res.data;
  } catch (err) {
    console.error(err?.response);
  }
};
export const fetchBatchCoursesWithoutPageService = data => async dispatch => {
  try {
    const courses = await fetchSchoolBatchCourseApi(data);
    dispatch(getSchoolBatchCourses(courses));
    return courses;
  } catch (err) {
    console.error(err.response);
  }
};

export const fetchBatchCourseService = data => async dispatch => {
  const { batchId = data?.batchId } = getGlobalCurrentBatchUtils();
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/admin/get-course-for-batch/${batchId}`,
      constants.setHeader(data.token)
    );
    if (res.data?.length) {
      dispatch(getBatchCoursesWithoutPage(res.data));
      return res.data;
    } else {
      const courses = await fetchSchoolBatchCourseApi(data);
      dispatch(getBatchCoursesWithoutPage(courses));
      return courses;
    }
  } catch (err) {
    console.error(err.response);
  }
};

export const saveCourseService = data => () => {
  return axios.post(
    `${constants.API_BASE_URL}/api/admin/create-course`,
    data.postData,
    constants.setHeader(data.token)
  );
};

export const fetchCourseService = data => async dispatch => {
  const res = await axios.get(
    `${constants.API_BASE_URL}/api/admin/get-course/${data.courseId}`,
    constants.setHeader(data.token)
  );
  return dispatch(getCourse(res.data));
};

export const updateCourseService = data => () => {
  return axios.put(
    `${constants.API_BASE_URL}/api/admin/update-course/${data.postData.courseId}`,
    data.postData,
    constants.setHeader(data.token)
  );
};

export const deleteCourseService = data => () => {
  return axios.delete(
    `${constants.API_BASE_URL}/api/admin/delete-course/${data.courseId}`,
    constants.setHeader(data.token)
  );
};

// Filter section
export const fetchEmployeeCoursesService = data => async dispatch => {
  const { batchId = data?.batchId } = getGlobalCurrentBatchUtils();
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/employee/course/${data.employeeId}/${batchId}`,
      constants.setHeader(data.token)
    );
    dispatch(getEmpCourses(res.data));
    return res.data;
  } catch (err) {
    console.error(err.response);
  }
};

export const generateTimeTableApi = async data => {
  const { courseId, token, schoolId } = data;
  console.log('data', data);
  const { batchId = data?.batchId } = getGlobalCurrentBatchUtils();
  return axios.post(
    `${constants.API_BASE_URL}/api/admin/time-table/auto-generate/${schoolId}/${batchId}/${courseId}`,
    null,
    constants.setHeader(token)
  );
};

// Single-page timetable allocation editor (view + cell save/clear).
export const fetchTimetableAllocationApi = async data => {
  const { schoolId, courseId, batchId, token } = data;
  return axios.get(
    `${constants.API_BASE_URL}/api/auth/timetable${constants.makeParams({ schoolId, courseId, batchId })}`,
    constants.setHeader(token)
  );
};

export const saveTimetableAllocationCellApi = async data => {
  const { schoolId, courseId, batchId, day, timePeriod, subjectId, token } = data;
  return axios.post(
    `${constants.API_BASE_URL}/api/auth/timetable/cell`,
    { schoolId, courseId, batchId, day, timePeriod, subjectId },
    constants.setHeader(token)
  );
};
//= ========== User routing end ===========//
